export default __webpack_public_path__ + "static/media/jood-screenshots.2ef33cc6.jpg";